import ChargesView from "./Charges.view";
function ChargesContainer(props) {
    return <ChargesView />;
}

export default ChargesContainer;
